import HasPermission from '@/components/HasPermission';
import Select from '@/common/Select';
import SelectNavigation from '@/common/SelectNavigation';
import { SelectNavigationTypes } from '@/common/SelectNavigation/types';

export type TrainingPageNavigationDropdownProps = Omit<SelectNavigationTypes.Props, 'routes'>;

const TrainingPageNavigationDropdown = (props: TrainingPageNavigationDropdownProps): JSX.Element => (
  <SelectNavigation {...props}>
    {HasPermission.check('allowViewTrainingSettings') && <Select.Option value="/settings/training/categories">Categories</Select.Option>}
    {HasPermission.check('allowViewTrainingSettings') && <Select.Option value="/settings/training/questions">Questions</Select.Option>}
  </SelectNavigation>
);

export default TrainingPageNavigationDropdown;
